import MainContainer from "../../components/MainContainer/";
export default function Home() {
  return (
    <>
      <MainContainer></MainContainer>
    </>
  );
}
